import { compose } from 'recompose';
import { withLabel } from '@/se/components/Label';
import ListPickerInput from '@/se/components/inputs/ListPickerInput';

export default compose(withLabel('Choose monitoring screen'))(ListPickerInput);
